import React from 'react';
import '../Events/event.css';
import image from '../Events/microfest.png';
import Gallery from '../Gallery/gallery';
import img from '../../Components/Images/image.webp';
import img1 from '../../Components/Images/image1.webp';
import img2 from '../../Components/Images/image2.webp';
import img3 from '../../Components/Images/image3.webp';
import img4 from '../../Components/Images/image4.webp';
import img5 from '../../Components/Images/image5.webp';

const Microfest = () => {
    const images = [
        {
            src: img,
            alt: "Image"
        },
        {
            src: img1,
            alt: "Image"
        }, {
            src: img2,
            alt: "Image"
        }, {
            src: img3,
            alt: "Image"
        }, {
            src: img4,
            alt: "Image"
        }, {
            src: img5,
            alt: "Image"
        },

    ]
    return (
        <>
            <section className="about">
                <div className="main">
                    <img src={image} alt="About Us" />
                    <div className="all-text">
                        <h1>Microfest</h1>
                        <p>
                            The much-anticipated "MicroFest" event, held on the 21st of September 2023, was a testament to the collaborative efforts between the Ozone Student Society and the esteemed Microbiology Department of the School of Health Sciences and Technology (SOHST). This grand affair attracted the attention of not only students and faculty but also high-profile attendees, including the Dean, Cluster Heads, and the distinguished Guest of Honour, Dr. V. Samuel Raj.
                            The event unfolded with a sense of anticipation as the Dean and Cluster Heads took the stage to deliver inspiring addresses. Their words set the tone for a day of exploration and engagement, promising a unique blend of academic insights, artistic expression, and infectious enthusiasm. The venue came alive with energetic dance performances and soul-stirring band presentations, infusing a vibrant touch into the atmosphere.
                        </p>
                        <p>
                            An exciting quiz competition followed, challenging the participants' knowledge and adding an element of healthy competition to the proceedings. This intellectual stimulation was further enhanced by the highlight of the day—an enlightening talk by the Guest of Honour, Dr. V. Samuel Raj. Dr. Raj delved into the critical topic of antibiotic resistance against tuberculosis, offering a wealth of information and provoking thoughtful reflection among the attentive audience. His presence added immense value to the event, emphasizing its significance in addressing crucial issues within the field of microbiology.
                            The spectrum of activities then broadened to encompass creativity, with competitions in T-shirt painting, agar arts, and model making. These contests provided a platform for students to showcase their artistic and scientific skills, fostering a sense of innovation and expression within the academic community. The Microbiology juniors injected an element of surprise into the event by organizing a lively flashmob outside the 11th block, captivating the audience and infusing the MicroFest with additional energy and enthusiasm.
                        </p>
                        <p>
                            As the day reached its culmination, an award distribution ceremony took center stage to recognize and celebrate the outstanding contributions of the participants. The event's organizers, Dr. Subhajit Basu and Dr. Smriti Arora, expressed their heartfelt gratitude in a poignant vote of thanks, acknowledging the collective effort that went into making MicroFest a resounding success.
                            In essence, MicroFest transcended the boundaries of a typical academic event. It emerged as a fusion of knowledge dissemination, artistic expression, and community engagement, leaving an indelible mark on all those fortunate enough to be in attendance. The collaborative spirit showcased during MicroFest exemplified the dynamic synergy between academia and student initiatives within the vibrant SOHST community.
                        </p>
                    </div>
                </div>
            </section>
            <Gallery images={images} />
        </>
    );
};

export default Microfest;
